import { useAuth } from '../AuthContext'
import { useCasquette } from '../contexts/casquette'
import { useActionsPortail } from '../contexts/navigation'
import RinaContextCard from '../components/RinaContextCard'
import PageHub from '../components/PageHub'
import ModuleCard, { useModulesPortail, SkeletonGrille, MODULE_FACETTES } from '../components/ModuleCard'
import { MVP } from '../mvp'

/**
 * Explorer — casquette PRODUCTEUR (S52, /producteur/explore) : la grille des
 * lieux avec les parcours producteur — Marche = « Participer » (module
 * producteur), Paniers = mes tournees. Toujours routables, independamment de
 * l'etat d'affichage CLIENT (BIENTOT) ; les autres lieux restent « Bientot ».
 * Pas de liste d'evenements ici : c'est un parcours client (PageExplorer).
 */
export default function PageExplorerProducteur() {
  const { user } = useAuth()
  const { isProducer } = useCasquette()
  const { ouvrirMarcheProducteur, ouvrirPaniersProducteur } = useActionsPortail()

  const modules = useModulesPortail()
  const userRoles = user ? ['client', ...(isProducer ? ['producteur'] : [])] : []

  return (
    <PageHub>
      <RinaContextCard message="Tous les lieux sont ici — entre dans Marché pour participer, ou Paniers pour gérer tes offres." />

      {modules === null ? (
        <SkeletonGrille />
      ) : (
        <div className="grid grid-cols-2 gap-3 auto-rows-fr">
          {modules.map((m, i) => {
            const onClick = m.code === 'MARCHE' ? () => ouvrirMarcheProducteur(null)
              : m.code === 'TOURNEE' && MVP.PANIERS ? ouvrirPaniersProducteur // MVP (S62)
              : undefined
            return (
              <ModuleCard
                key={m.code}
                module={m}
                enabled={!!onClick}
                onClick={onClick}
                animationDelay={`${i * 0.05}s`}
                facetteRoles={(MODULE_FACETTES[m.code] || []).filter((r) => userRoles.includes(r))}
              />
            )
          })}
        </div>
      )}
    </PageHub>
  )
}
